import { render, staticRenderFns } from "./TimeOffPolicyFormDialog.vue?vue&type=template&id=28dfac7a&"
import script from "./TimeOffPolicyFormDialog.vue?vue&type=script&lang=ts&"
export * from "./TimeOffPolicyFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports